export default __webpack_public_path__ + "static/media/1903.8c7a11fd.png";